import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/messages-management`;

export const messagesManagementRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
} as const;

export type IMessagesManagementRouteParams = IExtractRouteParamMap<
  typeof messagesManagementRoutesObj
>;

export const messagesManagementPath = createPaths<
  typeof messagesManagementRoutesObj,
  IMessagesManagementRouteParams
>(messagesManagementRoutesObj);
